<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-model="form.name"
			:error="inputErrors.name"
			label="name"
		/>
		<smart-input
			v-model="form.redirect"
			:error="inputErrors.redirect"
			label="redirect"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				:loading="inProgress"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import PassportModule from "src/store/modules/Passport.module";
import FormView from "src/mixins/FormView";

export default {
	name: "PassportForm",
	mixins: [new FormView(PassportModule, "authclient")],
	data () {
		return {
			form: {
			},
		};
	},
	computed: {
		isNew () {
			return !this.user.id;
		},
	},
};
</script>

<style scoped>

</style>
